import { Brand } from './brand.model';

export class BrandResponse {
  brandList: Brand[];
  total: number;

  constructor(brandList: Brand[], total: number) {
    this.brandList = brandList;
    this.total = total;
  }
}
